import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DocumentPreviewData } from './document-preview.models';

@Component({
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss'],
})
export class DocumentPreviewComponent implements OnInit {
  safeUrl: string | SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: DocumentPreviewData,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.getSafeUrl());
  }

  private getSafeUrl(): string {
    return `data:${this.data.type};base64,${this.data.string}`;
  }
}
